import React from 'react';
// import injectSheet from 'react-jss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { compose } from 'shared/helpers';
import {
  WELCOME_INTRO_ACCOUNT_TYPE,
  WELCOME_INIT_USER_PROFILE,
} from 'shared/constants/web';

import { Link } from 'components/elems';

// import { mixClasses as cx } from 'helpers';


// XXX:
// + Header opacity, rhs icon, footer position in small screen..
// + Upon confirming email, update user account type to 1



const IntroAccountTypeView = ({viewStack, handle}) => {

  return (
    <div className="flex pt5">
      <div className="w-40 ph5">
        <div className="moa-ff-gr black-70 f-subheadline lh-title">
          Welcome.
        </div>
      </div>

      <div className="w-60 ph5 black-70 lh-copy moa-ff-sans">
        <div className="f3 b mt3">
          Moagraph is <span className="underline">free</span> to
          use for creating and publishing
          contents <span className="underline">publicly</span>.
        </div>

        <div className="f5 mt4 pt3 mw6">
          <p>
            <span className="b">
              With Free account,
            </span> you have a place to put whatever
            you want out in the world, the way you want:
            micro posts, long form blogs, photos, GIFs, links,
            music tracks...
          </p>
          <p>
            <span className="b">
              One caveat though:
            </span> Free accounts can't follow or
            subscribe to other accounts, and everything you
            publish is public.
          </p>
          <p>
            Think of it like,
            playing a single player mode.
          </p>
        </div>

        <div className="tr mv4">
          <Link
            type="accented"
            to={{
              pathname: '/welcome',
              state: {
                viewStack: [...viewStack, WELCOME_INIT_USER_PROFILE],
                handle,
              },
            }}
          >
            Continue &#187;
          </Link>
        </div>

        <div className="black-30 f6 mt5">
          <div>***</div>
          <div className="mt1">
            Moagraph is currently only supporting Free accounts during
            pre-alpha phase.
          </div>
        </div>
      </div>
    </div>
  );
};


const InitUserProfileView = ({viewStack, handle}) => (
  <div className="pt5 ph3 mw6 center">
    <div className="black-70 lh-copy moa-ff-sans">
      <div className="f3 b i">
        This page is intentionally left blank..
      </div>
      <p className="f5 black-30">
        as a placeholder for updating profile and linking social accounts.
      </p>
    </div>
    <div className="tr mt5 moa-ff-sans">
      <Link
        type="accented"
        to={{
          pathname: '/welcome',
          state: {
            viewStack: [...viewStack, null],
            handle,
          },
        }}
      >
        Skip &#187;
      </Link>
    </div>
  </div>
);



function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    // setNavbarVisibility,
    // setFooterVisibility,
  }, dispatch);
}



class Welcome extends React.Component {
  componentWillMount() {
    // TODO: Manage headers?
  }

  render() {
    const {
      location: {
        state = {},
      },
    } = this.props;

    const {
      viewStack = [],
      // handle = null
    } = state;
    const [ current ] = viewStack.slice(-1);

    if (current === null) {
      return <Redirect to={{ pathname: "/" }} />;
    }

    const view = {
      [WELCOME_INTRO_ACCOUNT_TYPE]: <IntroAccountTypeView {...state} />,
      [WELCOME_INIT_USER_PROFILE]: <InitUserProfileView {...state} />,
    }[current];

    if (view === undefined) {
      return <Redirect to={{ pathname: '/' }} />;
    }

    return (
      <div className="min-vh-100 pt5 ph5 mw9 center">
        {view}
      </div>
    );
  }
}



export default compose(
  connect(null, mapDispatchToProps),
  // injectSheet(styles),
)(Welcome);



// WEBPACK FOOTER //
// ./src/pages/Welcome.js